/**
 * Thème global de l'application ShinySmile
 * Centralisé pour faciliter les modifications futures
 */

export const theme = {
  colors: {
    // Couleur principale (jaune/or)
    primary: {
      DEFAULT: '#FDE047', // yellow-300 (plus clair)
      light: '#FEF08A',   // yellow-200 (encore plus clair)
      dark: '#EAB308',    // yellow-500 (ancien défaut)
      hover: '#FACC15',   // yellow-400
    },

    // Backgrounds
    background: {
      main: '#060609',
      card: 'rgba(255, 255, 255, 0.05)',       // verre standard
      cardHover: 'rgba(255, 255, 255, 0.08)',
      input: 'rgba(0, 0, 0, 0.3)',             // verre en creux
      modal: 'rgba(18, 18, 26, 0.6)',          // verre profond
    },

    // Borders
    border: {
      light: 'rgba(255, 255, 255, 0.1)',
      primary: 'rgba(253, 224, 71, 0.5)', // yellow-300/50
      card: 'rgba(255, 255, 255, 0.1)',
    },

    // Text
    text: {
      primary: '#FFFFFF',   // white
      secondary: '#D1D5DB', // gray-300
      muted: '#9CA3AF',     // gray-400
    },

    // Status colors
    status: {
      pending: '#FDE047',     // yellow-300 (plus clair)
      inProgress: '#FDE047',  // yellow-300 (plus clair)
      shipped: '#A855F7',     // purple-500
      deleted: '#EF4444',     // red-500
      success: '#10B981',     // green-500
      warning: '#F59E0B',     // amber-500
      error: '#EF4444',       // red-500
    }
  },

  // Classes Tailwind pré-configurées pour réutilisation
  classes: {
    // Boutons
    button: {
      primary: 'bg-yellow-300 hover:bg-yellow-400 text-black px-6 py-2 rounded-lg font-medium transition-all duration-200',
      secondary: 'glass hover:bg-white/[0.08] text-white border border-white/10 px-6 py-2 rounded-lg font-medium transition-all duration-200',
      ghost: 'text-yellow-300 hover:text-yellow-200 transition-colors',
    },

    // Cards
    card: {
      default: 'glass border border-white/10 rounded-2xl',
      hover: 'glass border border-white/10 rounded-2xl hover:bg-white/[0.08] transition-all duration-200',
    },

    // Inputs
    input: {
      default: 'w-full px-4 py-3 bg-black/30 border border-white/[0.07] rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-yellow-300 focus:border-transparent transition-all',
      error: 'w-full px-4 py-3 bg-black/30 border border-red-500 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all',
    },

    // Backgrounds
    page: 'min-h-screen',
    modal: 'glass-deep rounded-2xl',
  }
};

export default theme;
